import { ordinal, rating } from "openskill";
import { ordinalToScaledDisplayRating } from "@/utils/scaled-display-rating";
import { subWeeks } from "date-fns";

function rgbToHex (r, g, b) {
  return "#" + [r, g, b].map(x => Math.round(x).toString(16).padStart(2, "0")).join("");
}

function hexToHsl (hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  const rgb = result
    ? { r: parseInt(result[1], 16), g: parseInt(result[2], 16), b: parseInt(result[3], 16) }
    : { r: 0, g: 0, b: 0 };
  const r1 = rgb.r / 255, g1 = rgb.g / 255, b1 = rgb.b / 255;
  const max = Math.max(r1, g1, b1), min = Math.min(r1, g1, b1);
  let h, s, l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
    case r1: h = ((g1 - b1) / d + (g1 < b1 ? 6 : 0)) / 6; break;
    case g1: h = ((b1 - r1) / d + 2) / 6; break;
    case b1: h = ((r1 - g1) / d + 4) / 6; break;
    }
  }
  return { h: h * 360, s: s * 100, l: l * 100 };
}

function hslToHex (h, s, l) {
  s /= 100;
  l /= 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  return rgbToHex(f(0) * 255, f(8) * 255, f(4) * 255);
}

export function generateShades (hex, count) {
  if (count === 0) return [];
  const { h, s } = hexToHsl(hex);
  const minL = 42;
  const maxL = 72;
  const shades = [];
  for (let i = 0; i < count; i++) {
    const l = count === 1 ? (minL + maxL) / 2 : minL + ((maxL - minL) * i) / (count - 1);
    shades.push(hslToHex(h, s, l));
  }
  return shades;
}

export function buildRatingDataPoints (sortedDocs, scorecard) {
  const points = [];
  for (let i = 0; i < sortedDocs.length; i++) {
    const doc = sortedDocs[i];
    const prevDoc = sortedDocs[i - 1];
    const ord = ordinal(rating({ mu: doc.mu, sigma: doc.sigma }));
    points.push({
      x: (i === 0 ? subWeeks(doc.createdAt.toDate(), 1) : prevDoc.createdAt.toDate()),
      y: ordinalToScaledDisplayRating(ord)
    });
  }
  if (scorecard && sortedDocs.length > 0) {
    const lastDoc = sortedDocs[sortedDocs.length - 1];
    const ord = ordinal(rating({ mu: scorecard.mu, sigma: scorecard.sigma }));
    points.push({
      x: lastDoc.createdAt.toDate(),
      y: ordinalToScaledDisplayRating(ord)
    });
  }
  return points;
}

export const chartClickMixin = {
  data () {
    return { selectedDatasetIndex: null };
  },
  methods: {
    handleChartClick (elements) {
      if (elements.length > 0) {
        const idx = elements[0].datasetIndex;
        this.selectedDatasetIndex = this.selectedDatasetIndex === idx ? null : idx;
      } else {
        this.selectedDatasetIndex = null;
      }
      this.applySelectedStyles();
    },
    applySelectedStyles () {}
  }
};

export const baseChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom"
    },
    tooltip: {
      mode: "nearest",
      intersect: false
    }
  }
};
